import '@/assets/css/fonts.css';
const requireCss = require.context('@/assets/fontawesome7pro/css', false, /\.css$/);

requireCss.keys().forEach(requireCss);